import { computed, observable, set } from 'mobx';
import { camelCaseData, processValue, toNumber } from '~utils/ToCamelCase';

type LoyaltyFieldType = string | number | null;
export interface ILoyaltyApiResponse {
    available_loyalty_points: LoyaltyFieldType;
    current_available_points: LoyaltyFieldType;
    level_number: LoyaltyFieldType;
    loyalty_active_flag: LoyaltyFieldType;
    loyalty_disenrolled_date: LoyaltyFieldType;
    loyalty_disenrolled_source: string;
    loyalty_email_promotions: LoyaltyFieldType;
    loyalty_email_sub_date: LoyaltyFieldType;
    loyalty_email_unsub_date: LoyaltyFieldType;
    loyalty_enrolled_date: LoyaltyFieldType;
    loyalty_enrolled_source: LoyaltyFieldType;
    loyalty_global_identifier: LoyaltyFieldType;
    loyalty_level_description: LoyaltyFieldType;
    loyalty_membership_number: LoyaltyFieldType;
    loyalty_program_id: LoyaltyFieldType;
    next_anniversary_date: LoyaltyFieldType;
    pointsnextlevel: LoyaltyFieldType;
    tier?: LoyaltyFieldType;
}

class LoyaltyInfo {
    @observable public currentPoints: number = 0;
    @observable public hasLoyalty: boolean = false;
    @observable public levelDescription: string = '';
    @observable public tier: string = '';
    @observable public levelValue: number = 1;

    static fromJSON(loyaltyApiResponse: ILoyaltyApiResponse): LoyaltyInfo {
        const loyalty = new LoyaltyInfo();
        const prefixToRemove = 'loyalty_';
        const {
            level_number,
            loyalty_program_id,
            available_loyalty_points,
            current_available_points,
            pointsnextlevel,
            loyalty_active_flag,
            ...apiData
        } = loyaltyApiResponse;

        const data = camelCaseData(apiData, prefixToRemove);

        const modifiedData = {
            ...data,
            availablePoints: toNumber(available_loyalty_points),
            currentPoints: toNumber(current_available_points),
            hasLoyalty: processValue(loyalty_active_flag),
            levelValue: toNumber(level_number, 1),
            nextLevelPoints: toNumber(pointsnextlevel),
            programId: toNumber(loyalty_program_id)
        };

        set(loyalty, modifiedData);

        return loyalty;
    }

    @computed public get loyaltyPoints(): number {
        return this.currentPoints;
    }
}

export default LoyaltyInfo;
